// extracted by mini-css-extract-plugin
export default {"pageWrapper":"AdminCourseEditPage_pageWrapper__zCqSL"};